import axios from 'axios';
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { api, refreshAuthToken } from '../utils/lib';

export const useApi = () => {
  const auth = useAuth();
  const token = auth?.user?.access_token;

  useEffect(() => {
    const responseInterceptor = api.interceptors.response.use(
      (response) => response, // Pass successful responses through
      async (error) => {
        const originalRequest = error.config;
        if (auth.isAuthenticated) {
          if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
              // manual refresh
              const newUser = await auth.signinSilent();
              if (newUser?.access_token) {
                // retry original request
                return api(originalRequest);
              }
            } catch (refreshError) {
              // back to login
              auth.signinRedirect();
            }
          }
        } else {
          if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            return refreshAuthToken()
              .then(response => axios(originalRequest));
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      api.interceptors.response.eject(responseInterceptor);
    };
  }, [token, auth]);

  return api;
};